import React from "react";
import { useAuth } from "../lib/auth";
import { useContent } from "../lib/content";
import { Clock, LogOut, Phone, Mail } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const { t } = useContent();
  const phone = t("landing_phone", "+421 900 000 000");
  const email = t("landing_email", "info@proparts.sk");
  // tel: URI must be digits + leading "+" only.
  const phoneHref = `tel:${phone.replace(/[^\d+]/g, "")}`;

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="topbar">
        <div className="max-w-[1200px] mx-auto px-4 h-9 flex items-center justify-between">
          <div className="flex items-center gap-2"><Phone size={11} /><span>PROPARTS.SK — B2B</span></div>
          <button onClick={logout} className="hover:opacity-80 flex items-center gap-1" data-testid="logout-button">
            <LogOut size={11} /> Odhlásiť
          </button>
        </div>
      </div>

      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="card-elev max-w-xl w-full">
          <div className="section-title" style={{ background: "linear-gradient(to bottom,#DC8A00,#B86F00)" }}>
            <Clock size={14} className="inline mr-2" /> Čaká na schválenie
          </div>
          <div className="p-8 text-center">
            <div
              className="w-16 h-16 mx-auto mb-5 rounded-full flex items-center justify-center"
              style={{ background: "#FFF4E0", border: "2px solid #DC8A00" }}
            >
              <Clock size={28} style={{ color: "#DC8A00" }} />
            </div>

            <h1 className="text-2xl font-bold mb-3 uppercase">Ďakujeme za registráciu!</h1>
            <p className="text-sm mb-2" style={{ color: "var(--text-mute)" }}>
              Vitajte, <strong style={{ color: "var(--text)" }}>{user?.name || user?.email}</strong>
            </p>
            <p className="text-sm mb-6" style={{ color: "var(--text-mute)" }}>
              Váš účet ešte <strong style={{ color: "#DC8A00" }}>čaká na schválenie</strong>. Náš vedúci predaja
              čoskoro prehliadne vaše údaje a nastaví vašu individuálnu zmluvnú cenovú kategóriu. Po schválení budete
              mať okamžitý prístup k celému katalógu a môžete zadať objednávku.
            </p>

            <div className="my-6 p-4 text-left text-xs space-y-2" style={{ background: "var(--surface-elev)", border: "1px solid var(--border)", borderRadius: 4 }}>
              <div className="font-bold uppercase mb-1" style={{ color: "var(--text)" }}>Zadané údaje:</div>
              <Detail label="E-mail" value={user?.email} />
              <Detail label="Názov firmy / Servisu" value={user?.company} />
              <Detail label="IČ DPH" value={user?.tax_id} />
              <Detail label="Telefón" value={user?.phone} />
            </div>

            <div className="text-xs p-3 mb-5" style={{ background: "#FFFEF0", border: "1px solid var(--brand)", borderRadius: 4 }}>
              <strong>Rýchlejšie spracovanie:</strong> Zavolajte nám a povedzte svoju e-mailovú adresu — účet aktivujeme do niekoľkých minút.
            </div>

            <div className="flex justify-center gap-2 flex-wrap">
              <a href={phoneHref} className="btn-primary" data-testid="call-admin-btn">
                <Phone size={14} /> Volať: {phone}
              </a>
              <a href={`mailto:${email}`} className="btn-ghost" data-testid="email-admin-btn">
                <Mail size={14} /> {email}
              </a>
            </div>

            <p className="text-[10px] mt-6" style={{ color: "var(--text-mute)" }}>
              Skúste to znovu o pár minút — alebo počkajte na e-mailové upozornenie.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}

function Detail({ label, value }) {
  if (!value) return null;
  return (
    <div className="flex justify-between">
      <span style={{ color: "var(--text-mute)" }}>{label}:</span>
      <span className="font-bold">{value}</span>
    </div>
  );
}
